export const getBusinessId = (tenantid) => {
  tenantid = Number(tenantid);
  switch (tenantid) {
    case 287:
      return 359;
    case 290:
      return 320;
    case 484:
      return 580;
    case 492:
      return 611;
    case 501:
      return 618;
    case 523:
      return 619;
    case 525:
      return 624;
    case 524:
      return 622;
    default:
      return 320;
  }
};
